if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form
                    .querySelector("[name=id]")
                    ?.removeAttribute?.("disabled");
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );

                // gift card product - recipient form
                this.recipientForm = this.querySelector("recipient-form");
            }

            getSubmitButton() {
                var formId = this.form.getAttribute("id");

                return (
                    this.querySelector('[type="submit"]') ||
                    document.querySelector('[form="' + formId + '"]')
                );
            }

            getMessageWrapper() {
                this.messageWrapper =
                    this.messageWrapper ||
                    this.querySelector(".message-wrapper");

                if (this.messageWrapper) {
                    return this.messageWrapper;
                }

                this.messageWrapper = createFromTemplate("message-wrapper");
                this.getSubmitButton()?.after(this.messageWrapper);

                return this.messageWrapper;
            }

            connectedCallback() {
                this.quantityInput = document.querySelector(`input[name="quantity"].quantity__input[form="${this.form.getAttribute('id')}"]`)
            }

            getCartJson() {
                return fetch(window.Shopify.routes.root + "cart.js", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }).then((response) => response.json());
            }

            async handleSubmitError(response) {
                const cart = document.querySelector("cart-sidebar");
                const itemCount = +cart?.querySelector?.(".cart-sidebar__total")
                    ?.dataset?.itemCount;
                const newCartJson = await this.getCartJson();

                this.handleErrorMessage(response.description);
                if (itemCount === newCartJson.item_count) return;

                await cart.reload();
                let line = 1;
                let variantId = [...this.form.elements].find(
                    (el) => el.name === "id"
                )?.value;
                if (variantId) {
                    newCartJson.items?.forEach?.((item, index) => {
                        if (item.variant_id === +variantId) line = index + 1;
                    });
                }

                cart.revealStickyHeaderAndOpen() || cart.open();
            }

            async onSubmitHandler(evt) {
                evt.preventDefault();

                // Get selected string option (dropdown or radio)
                const dropdown = document.getElementById('custom_product_options_select');
                const checkedRadio = document.querySelector('input[name="custom_product_options"]:checked');
                const selectedStringOption = dropdown?.value || checkedRadio?.value || 'unstrung';
                
                const cart = document.querySelector("cart-sidebar");
                const submitButton = this.getSubmitButton();
                if (submitButton.classList.contains("loading")) return;
                
                // Variables for string items (only used if NOT unstrung)
                let mainStringVariantId, mainStringDiscount, crossStringVariantId, crossStringDiscount;
                
                // Only validate and process string items if NOT unstrung
                if (selectedStringOption !== 'unstrung') {
                    const mainStringTensionElement = this.form.querySelector('input[name="properties[Main String Tension]"]');
                    const crossStringTensionElement = this.form.querySelector('input[name="properties[Cross String Tension]"]');
                    
                    // Validate main string tension
                    if (mainStringTensionElement) {
                        const mainStringTension = mainStringTensionElement.value;
                        if (!mainStringTension) {
                            this.handleErrorMessage('Please select a main string tension');
                            return;
                        }
                    }

                    // Validate cross string tension for hybrid
                    if (selectedStringOption === 'hybrid' && crossStringTensionElement) {
                        const crossStringTension = crossStringTensionElement.value;
                        if (!crossStringTension) {
                            this.handleErrorMessage('Please select a cross string tension');
                            return;
                        }
                    }
                    
                    // Get string variant IDs and discounts
                    mainStringVariantId = this.form.querySelector('input[name="properties[_custom_string_main_variant_id]"]')?.value;
                    mainStringDiscount = this.form.querySelector('input[name="properties[_custom_string_main_discount]"]')?.value;
                    crossStringVariantId = this.form.querySelector('input[name="properties[_custom_string_cross_variant_id]"]')?.value;
                    crossStringDiscount = this.form.querySelector('input[name="properties[_custom_string_cross_discount]"]')?.value;

                    // Validate main string selection
                    if (!mainStringVariantId) {
                        this.handleErrorMessage('Please select a main string');
                        return;
                    }

                    // Validate cross string selection for hybrid
                    if (selectedStringOption === 'hybrid' && !crossStringVariantId) {
                        this.handleErrorMessage('Please select a cross string');
                        return;
                    }
                }
                
                this.handleErrorMessage();
                
                if (!submitButton.querySelector(".loading-overlay"))
                    submitButton.prepend(
                        createFromTemplate("template-loading-overlay")
                    );
                
                submitButton.setAttribute("aria-disabled", true);
                submitButton.classList.add("loading");
                
                cart?.setActiveElement?.(document.activeElement);
                
                const formData = new FormData(this.form);
                const variantId = formData.get('id');
                
                // Build items array with parent and nested children
                const items = [];
                const quantity = this.quantityInput?.value || 1;
                
                // Add main product with properties
                const mainItem = {
                    id: variantId,
                    quantity: quantity
                };
                
                // Collect all properties from form
                const properties = {};
                for (let [key, value] of formData.entries()) {
                    if (key.startsWith('properties[')) {
                        const propName = key.replace('properties[', '').replace(']', '');
                        properties[propName] = value;
                    }
                }
                
                // Generate unique bundle_id ONLY if we have nested products AND not unstrung
                let bundleId = null;
                if (selectedStringOption !== 'unstrung' && (mainStringVariantId || crossStringVariantId)) {
                    // Using timestamp + random number ensures each bundle is unique
                    bundleId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                    properties['_parent_bundle_id'] = bundleId;
                }
                
                if (Object.keys(properties).length > 0) {
                    mainItem.properties = properties;
                }
                
                items.push(mainItem);
                
                // Add nested string items ONLY if NOT unstrung
                if (selectedStringOption !== 'unstrung') {
                    // Add main string item
                    if (mainStringVariantId && bundleId) {
                        const mainStringProperties = {
                            _bundle_id: bundleId,
                            _discount_percentage: mainStringDiscount || '0'
                        };
                        // Only tag with role when paired with a cross string (hybrid mode) —
                        // in standard mode there is only one string, so labelling as "Mains" is misleading.
                        if (selectedStringOption === 'hybrid' && crossStringVariantId) {
                            mainStringProperties._string_role = 'main';
                        }
                        const mainStringItem = {
                            id: mainStringVariantId,
                            parent_id: variantId,
                            quantity: quantity,
                            properties: mainStringProperties
                        };
                        items.push(mainStringItem);
                    }
                    
                    // Add cross string item (only for hybrid)
                    if (crossStringVariantId && bundleId) {
                        const crossStringItem = {
                            id: crossStringVariantId,
                            parent_id: variantId,
                            quantity: quantity,
                            properties: {
                                _bundle_id: bundleId,
                                _discount_percentage: crossStringDiscount || '0',
                                _string_role: 'cross'
                            }
                        };
                        items.push(crossStringItem);
                    }
                }
                
                // Use JSON config to send all items in one request
                const config = fetchConfig("json");
                config.body = JSON.stringify({
                    items: items,
                    sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
                    sections_url: window.location.pathname
                });
                
                try {
                    const response = await fetch(
                        `${routes.cart_add_url}`,
                        config
                    );
                    const jsonResponse = await response.json();
            
                    if (!response.ok || jsonResponse.status) {
                        this.handleSubmitError(jsonResponse);
                        return;
                    }
            
                    if (cart && jsonResponse.sections) {
                        // Has cart sidebar - update it
                        cart.renderContents(jsonResponse);
                    } else {
                        // No cart sidebar - redirect to cart page
                        window.location.href = window.Shopify?.routes?.root ? 
                            `${window.Shopify.routes.root}cart` : '/cart';
                    }
            
                    if (this.recipientForm)
                        this.hideRecipientForm(this.recipientForm);
            
                    document
                        .querySelector("#PopupModal-quickView")
                        ?.removeAttribute?.("open");
                } catch (error) {
                    console.error("Error submitting form:", error);
                    // Fallback: redirect to cart
                    window.location.href = window.Shopify?.routes?.root ? 
                        `${window.Shopify.routes.root}cart` : '/cart';
                } finally {
                    submitButton.classList.remove("loading");
                    submitButton.removeAttribute("aria-disabled");
                }
            }

            hideRecipientForm(recipientForm) {
                const input = recipientForm.querySelector("input");
                const fields = recipientForm.querySelector(".recipient-fields");

                if (input.checked) {
                    let animation = fields.animate(
                        { height: [fields.clientHeight + "px", "0"] },
                        { duration: 300, easing: "linear" }
                    );

                    input.checked = false;
                    animation.onfinish = () => {
                        fields.style.height = "0";
                    };
                }
            }

            handleErrorMessage(errorMessage = false) {
                const messageWrapper = this.getMessageWrapper();

                // gift-card recipient form error messages
                if (
                    errorMessage.email ||
                    errorMessage.send_on ||
                    errorMessage.message
                )
                    errorMessage =
                        errorMessage.email ||
                        errorMessage.send_on ||
                        errorMessage.message;

                this.errorMessage =
                    this.errorMessage ||
                    messageWrapper.querySelector(".error-message");
                this.errorMessage.textContent = errorMessage || "";
                if (errorMessage) messageWrapper.removeAttribute("hidden");
                else messageWrapper.setAttribute("hidden", true);
            }
        }
    );
}
